export const zhHantTW = {
  translation: {
    common: {
      loading: '正在載入...',
      error: '錯誤',
      button: '返回儀表板',
      goToDashboard: '返回儀表板',
    },
    noPermission: {
      title: '沒有權限',
      description: '您沒有權限訪問此頁面。',
      goToDashboardDescription: '您沒有權限訪問此頁面。請聯繫管理員以獲取訪問權限。',
      goToDashboardButton: '返回儀表板',
    },
    'Add Fulfillment': '新增履約',
    'Input Your data': '輸入您的資料',
    Name: '名稱',
    Select: '選擇',
    search: {
      placeholder: '搜尋',
    },
    login: {
      title: '登入 與 Xinchuan Auth',
      button: '登入',
      success: '登入成功',
      authCallback_authentication_failed: '身份驗證登入失敗。回呼身份驗證失敗：{error}',
      authCallback_invalid_parameters: '回呼身份驗證登入參數無效',
      authCallback_invalid_state_parameter: '回呼驗證登入狀態參數無效',
      authCallback_failed: '回呼身份驗證登入失敗',
      authCallback_success: '回呼驗證登入成功',
      authCallback_completing_authentication: '回呼驗證登入完成',
      authCallback_redirecting: '回呼驗證登入已重新導向',
    },
    sidebar: {
      overview: '概覽',
      operational: '營運',
      dashboard: '儀表板',
      fulfillment: '管理履行',
      addFulfillment: '新增履約',
      aggregator: '管理聚合器',
      report: '報告中心',
      products: '產品',
      wallet: '錢包餘額',
      logout: '登出',
      product_group: '產品群組',
      product_management: '產品管理',
      voucherpin: 'Voucher PIN',
      voucher_pin_import: '匯入 Voucher PIN',
    },
    pages: {
      wallet: '管理錢包餘額',
      report: '報告中心',
      product_group: '產品群組',
      product_management: '產品管理',
    },
    Button: {
      Info: '資訊',
      Success: '成功',
      Error: '錯誤',
      Warning: '警告',
      Confirm: '確認',
    },
    fileUpload: {
      uploading: '正在上傳',
      attach_files: '透過拖放、貼上或點擊此處上傳檔案',
      errors: {
        file_too_large: '檔案過大。最大檔案大小為 {size}MB。',
        max_files: '最多允許上傳 {max} 個檔案。您還有 {remaining} 個剩餘上傳空間。',
        invalid_content: '檔案內容無效。請上傳有效的圖片（JPEG、PNG 或 SVG）。',
        upload_failed: '上傳失敗。請重試。',
      },
      success: '檔案上傳成功。',
      errors_upload_failed: '上傳失敗。請重試。',
    },
    imageUpload: {
      uploading: '正在上傳',
      attach_files: '透過拖放、貼上或點擊此處上傳檔案',
      addPhoto: '新增照片',
      main: '主圖',
      setAsMain: '設為主圖',
      success: '圖片上傳成功。',
      errors: {
        file_too_large: '檔案過大。最大檔案大小為 {size}MB。',
        max_files: '最多允許上傳 {max} 個檔案。您還有 {remaining} 個剩餘上傳空間。',
        invalid_content: '檔案內容無效。請上傳有效的圖片（JPEG、PNG 或 SVG）。',
        upload_failed: '上傳失敗。請重試。',
        not_image: '請選擇圖片檔案。',
      },
    },
    pagination: {
      prev: '上一頁',
      next: '下一頁',
      prevPageAria: '上一頁',
      nextPageAria: '下一頁',
    },
    table: {
      filterReset: '重置',
    },
    ui: {
      cancel: '取消',
      imageCrop: {
        title: '上傳圖片',
        save: '儲存',
        invalid: '請上傳 JPG 或 PNG 圖片，大小不超過 {{max}} MB。',
      },
      emptyState: {
        noData: '沒有資料',
      },
      chart: {
        noData: '沒有圖表資料。',
      },
      dateTimeRangeFilter: {
        startDate: '開始日期',
        endDate: '結束日期',
      },
      statusBadge: {
        available: '可用',
        unavailable: '不可用',
        hidden: '隱藏',
        disabled: '已停用',
        success: '成功',
        pending: '待處理',
        failed: '失敗',
        refunded: '已退款',
        uncertain: '不確定',
        processing: '處理中',
      },
    },

    report: {
      selectSection: '從選單選擇報告類型',
      category: '報告類別',
      fulfillment: {
        item: '履約',
        title: '項目履約',
        description: '為所選期間產生項目採購報告',
        supplier: '供應商',
        supplierPlaceholder: '選擇供應商',
        period: '期間',
        export: '匯出',
      },
    },
    fulfillment: {
      empty: '沒有符合篩選條件的履約記錄。',
      columns: {
        transactionId: '交易 ID',
        invoiceNumber: '發票號碼',
        foreignOrderId: '外部訂單 ID',
        status: '狀態',
        supplier: '供應商',
        product: '產品',
        cost: '成本',
        walletBalance: '錢包餘額',
        createdAt: '建立時間',
        fulfilledAt: '履行時間',
        errorMessage: '錯誤訊息',
      },
      filters: {
        transactionIdPlaceholder: '交易 ID',
        invoiceNumberPlaceholder: '發票號碼',
        foreignOrderRefsPlaceholder: '輸入 ref（按 Enter 新增）',
      },
      suppliers: {
        alterra: 'Alterra',
        billfazz: 'Billfazz',
      },
      rowActions: {
        expandRow: '展開列',
        collapseRow: '收合列',
      },
      overview: {
        generalInfo: '一般資訊',
        orderDetail: '訂單詳情',
        notes: '備註',
        destination: '目的地',
        errorMessage: '錯誤訊息',
        noErrorMessage: '沒有錯誤訊息',
        errorCode: '錯誤代碼',
        vendorErrorCode: '供應商錯誤代碼',
        vendorErrorMessage: '供應商錯誤訊息',
      },
    },
    aggregator: {
      empty: '沒有符合篩選條件的聚合器產品。',
      columns: {
        product: '產品',
        sku: 'SKU 代碼',
        type: '類型',
        status: '狀態',
        actions: '操作',
        errorMessage: '錯誤訊息',
        vendorCost: '採購成本',
      },
      type: {
        prepaid: '預付',
        postpaid: '後付',
      },
      filters: {
        productPlaceholder: '產品',
        idPlaceholder: 'ID',
        available: '可用',
        unavailable: '不可用',
      },
      status: {
        available: '可用',
        unavailable: '不可用',
      },
      rowActions: {
        action: '操作',
        edit: '編輯',
        enable: '啟用',
        disable: '停用',
        expandRow: '展開列',
        collapseRow: '收合列',
      },
      statusModal: {
        disableTitle: '停用產品？',
        enableTitle: '啟用產品？',
        disableConfirm: '停用',
        enableConfirm: '啟用',
        cancel: '取消',
        warningTitle: '警告',
        disableImpact: '停用此產品後，客戶將無法購買，直到再次啟用為止。',
        disableSuccess: '產品已成功停用',
        enableSuccess: '產品已成功啟用',
        disablePrompt: '您確定要停用',
        enablePrompt: '您確定要啟用',
        disableNote: '產品將保持停用狀態，直到手動再次啟用。',
        enableNote: '此操作將使產品可供履行使用。',
      },
      overview: {
        generalInfo: '一般資訊',
        aggregatorInfo: '聚合器資訊',
        name: '名稱',
        vendor: '供應商',
        vendorSku: 'SKU',
        priority: '優先順序',
        procurementCost: '採購成本',
      },
      editModal: {
        title: '編輯產品',  
        saveChanges: '儲存變更',
        productInfo: '產品資訊',
        productName: '產品名稱',
        aggregatorMappings: '聚合器對應',
        aggregatorColumn: '聚合器',
        updateSuccess: '產品更新成功',
      },
    },
    productGroup: {
      empty: '沒有符合篩選條件的產品群組。',
      columns: {
        product: '產品',
        price: '價格',
        actions: '操作',
      },
      actions: {
        import: '匯入',
        export: '匯出',
        newGroup: '新增群組',
      },
      rowActions: {
        action: '操作',
        edit: '編輯',
        editProduct: '編輯產品',
        addChild: '新增子項',
        addPlanGroup: '新增方案群組',
        attachProduct: '附加產品',
        changeOrder: '調整順序',
        detachProduct: '解除附加產品',
        enable: '啟用',
        disable: '停用',
        delete: '刪除',
        expandRow: '展開列',
        collapseRow: '收合列',
      },
      modals: {
        createTitle: '新增群組',
        editGroupTitle: '編輯群組',
        changeOrderTitle: '調整順序',
        changeOrderEmpty: '此群組尚無產品',
        saveChanges: '儲存變更',
        reorder: '拖曳以調整順序',
        orderSaved: '已儲存順序',
        editProductTitle: '編輯產品',
        attachTitle: '附加產品',
        deleteTitle: '刪除群組',
        deleteProductTitle: '刪除產品',
        detachTitle: '解除附加產品',
        deletePrompt: '確定要刪除「<bold>{{name}}</bold>」嗎？',
        deleteProductPrompt: '確定要刪除「<bold>{{name}}</bold>」嗎？',
        deleteConfirm: '刪除',
        deleteNote: '此動作無法復原。',
        deleteImpact: '刪除後會從目錄中移除，顧客將無法再看到它。',
        detachPrompt: '確定要解除附加「<bold>{{name}}</bold>」嗎？',
        groupInformation: '群組資訊',
        name: '名稱',
        namePlaceholder: '輸入名稱',
        nameRequired: '名稱為必填',
        photo: '照片',
        groupType: '群組類型',
        section: '區塊',
        sectionPlaceholder: '選擇區塊',
        sectionRequired: '區塊為必填',
        parentGroup: '上層群組',
        parentPlaceholder: '選擇上層群組',
        hidden: '隱藏',
        upload: '上傳',
        changeImage: '更換圖片',
        removeImage: '移除圖片',
        imageHint: '*僅限<bold>圖片</bold>格式（最大 <bold>2MB</bold>）',
        imageTransparent: '圖片需含<bold>透明背景</bold>，綠色背景才會保持可見。',
        imageTypeError: '圖片必須為 JPG、PNG 或 JPEG。',
        imageSizeError: '圖片不可超過 2 MB。',
        types: {
          subgroup: '子群組',
          product: '產品',
          esimCountry: 'ESIM 國家',
        },
        sections: {
          dataPerDay: '每日流量',
          dataInTotal: '總流量',
        },
        save: '儲存變更',
        createGroup: '建立群組',
        cancel: '取消',
        yes: '是',
        no: '否',
        attach: '附加產品',
        product: '產品',
        products: '產品',
        selectProduct: '選擇產品',
        noProducts: '沒有符合的產品。',
        loadingProducts: '正在載入產品…',
        attachLoadError: '載入產品失敗',
        productName: '產品名稱',
        price: '價格',
        availability: '可用性',
        available: '可用',
        notAvailable: '不可用',
        productStatus: '產品狀態',
        enabled: '啟用',
        disabled: '停用',
        visibility: '可見性',
        visible: '顯示',
        refundable: '可退款',
        productDisabled: '產品已停用',
        availableHint: '可購買此商品',
        notAvailableHint: '無法購買此商品',
        visibleHint: '顯示於列表中',
        hiddenHint: '已從列表中隱藏',
        enabledHint: '商品已啟用且可正常使用',
        disabledHint: '商品未啟用',
        refund: '退款',
        nonRefundable: '不可退款',
        refundableHint: '此商品可申請退款',
        nonRefundableHint: '此商品不可申請退款',
        locale: '語系',
        description: '說明',
        descriptionPlaceholder: '輸入說明',
        rootParent: '無（根節點）',
        created: '已建立群組',
        updated: '已更新群組',
        productUpdated: '已更新產品',
        deleted: '已刪除「{{name}}」',
        productDeleted: '已刪除「{{name}}」',
        detached: '已解除附加「{{name}}」',
        attached: '已附加產品',
      },
      statusModal: {
        disableTitle: '停用產品？',
        enableTitle: '啟用產品？',
        disableConfirm: '停用',
        enableConfirm: '啟用',
        cancel: '取消',
        warningTitle: '警告',
        disableImpact: '停用此產品後，客戶將無法購買，直到再次啟用為止。',
        disableSuccess: '產品已成功停用',
        enableSuccess: '產品已成功啟用',
        disablePrompt: '您確定要停用',
        enablePrompt: '您確定要啟用',
        disableNote: '產品將保持停用狀態，直到手動再次啟用。',
        enableNote: '此操作將使產品可再次購買。',
      },
    },
    productManagement: {
      empty: '沒有符合篩選條件的產品。',
      columns: {
        product: '產品',
        price: '價格',
        priceScheme: '價格方案',
        schemes: {
          fixed: '固定',
          per_account: '依帳戶',
          user_defined: '使用者定義',
        },
        type: '類型',
        types: {
          unit: '單位',
          bundle: '組合',
        },
        description: '說明',
        status: '狀態',
        actions: '動作',
      },
      status: {
        available: '可用',
        unavailable: '不可用',
        hidden: '隱藏',
        disabled: '已停用',
      },
      actions: {
        import: '匯入',
        export: '匯出',
        changeOrder: '調整順序',
      },
      export: {
        title: '匯出',
        provider: '供應商',
        allProviders: '所有供應商',
        medium: '媒介',
        allMediums: '所有媒介',
        electronic: '電子',
        voucherPin: 'Voucher PIN',
        supplier: '供貨商',
        allSuppliers: '所有供貨商',
        cancel: '取消',
        export: '匯出',
        exported: '已匯出產品',
        failed: '匯出失敗',
        stillProcessing: '匯出仍在處理中',
        unitHint: '檔案只包含單位產品。',
      },
      changeOrder: {
        title: '調整順序',
        provider: '供應商',
        selectProvider: '選擇供應商',
        cancel: '取消',
        saveChanges: '儲存變更',
        saved: '已儲存 {{provider}} 產品順序',
      },
      import: {
        title: '匯入檔案',
        uploadData: '上傳資料',
        downloadTemplate: '下載<template>範本</template>以查看所需格式。',
        dropHint: '點擊或拖曳檔案至此處上傳',
        singleFile: '僅可上傳單一檔案。',
        formats: '支援格式：XLSX, XLS, 和 CSV。',
        cancel: '取消',
        upload: '上傳',
        data: '資料',
        status: '狀態',
        errorDetails: '錯誤詳情',
        valid: '有效',
        invalid: '無效',
        missingColumn: '缺少欄位',
        successNote: '僅會上傳成功的列',
        invalidType: '請上傳 XLSX 檔案。',
        imported: '已匯入產品',
        started: '已開始匯入',
        failed: '匯入失敗',
        skipped: '已略過 {{count}} 列',
        stillProcessing: '匯入仍在處理中',
        row: '列',
        field: '欄位',
        message: '訊息',
        summary: '已寫入 {{written}} 個產品。略過 {{skipped}}。',
        logNote: '請查看未寫入的列。',
        noneValid: '沒有可匯入的有效欄位',
        columns: {
          id: 'ID',
          name: '名稱',
          fapiao_name: '發票名稱',
          medium: '媒介',
          price: '價格',
          reference_cost_price: '成本價',
          price_scheme: '價格方案',
          supplier_product_code: '供應商產品代碼',
          denomination_currency: '面額幣別',
          denomination: '面額',
          type: '類型',
        },
      },
      rowActions: {
        action: '操作',
        setInstruction: '設定說明',
        edit: '編輯',
        enable: '啟用',
        disable: '停用',
      },
      instruction: {
        title: '設定說明',
        locale: '語系',
        instruction: '說明',
        placeholder: '輸入說明',
        add: '新增說明',
        remove: '移除說明',
        cancel: '取消',
        saveChanges: '儲存變更',
        saved: '已儲存說明',
      },
      edit: {
        title: '編輯產品',
        photoLabel: '照片',
        cancel: '取消',
        back: '返回',
        next: '下一步',
        saveChanges: '儲存變更',
        saved: '已更新產品',
        photo: '照片',
        uploadTitle: '上傳圖片',
        uploadSave: '儲存',
        name: '名稱',
        description: '說明',
        descriptionPlaceholder: '輸入說明',
        locale: '語系',
        imageHint: '*僅限圖片格式（最大 2MB）',
        imageTransparent: '請使用透明背景圖片，以便看見綠色背景。',
        steps: {
          info: '產品資訊',
          details: '產品詳情',
          visibility: '可見性與存取',
        },
        pricing: '定價',
        priceScheme: '價格方案',
        priceCurrency: '價格幣別',
        price: '價格',
        priceBundleHint: '此價格依組合計算，請在組合價格中修改。',
        referenceCostCurrency: '參考成本幣別',
        referenceCostPrice: '參考成本價格',
        denominationCurrency: '面額幣別',
        denomination: '面額',
        productDetails: '產品詳情',
        medium: '媒介',
        type: '類型',
        supplierProductCode: '供貨商產品代碼',
        productBundle: '產品組合',
        bundleSearch: '例如 IF 或 IF 50 NT',
        bundleCount: '{{count}} 項',
        total: '總計',
        availability: '可用性',
        available: '可用',
        availableHint: '商品可以購買',
        notAvailable: '不可用',
        notAvailableHint: '商品無法購買',
        productStatus: '產品狀態',
        enabled: '啟用',
        enabledHint: '商品有效且可使用',
        disabled: '停用',
        disabledHint: '商品已停用',
        visibility: '可見性',
        visible: '顯示',
        visibleHint: '出現在列表中',
        hidden: '隱藏',
        hiddenHint: '從列表中隱藏',
        access: '存取',
        publicAccess: '公開存取',
        publicAccessHint: '所有使用者可見',
        restrictedAccess: '限制存取',
        restrictedAccessHint: '僅部分使用者可見',
        refundable: '可退款',
        schemes: { fixed: '固定', per_account: '依帳戶', user_defined: '使用者定義' },
        mediums: { voucher_pin: '儲值密碼', electronic: '電子' },
        types: { unit: '單位', bundle: '組合' },
        bundleColumns: {
          product: '產品',
          qty: '數量',
          price: '價格',
          subtotal: '小計',
          action: '操作',
        },
      },
    },
    wallet: {
      average_spending_per_day: '平均每日支出',
      history: '錢包歷史',
      chart_balance: '餘額',
      chart_change: '變化',
      columns: {
        provider: '提供者',
      },
    },
    voucherPinImport: {
      title: '匯入 Voucher PIN',
      search: '搜尋 SKU 代碼或名稱',
      skuId: 'SKU ID',
      status: '狀態',
      template: '下載範本',
      uploadButton: '上傳檔案',
      empty: '沒有匯入批次',
      ownBatches: '只列出你建立的批次。',
      columns: {
        batch: '批次',
        sku: 'SKU',
        file: '檔案',
        source: '來源',
        status: '狀態',
        cost: '成本',
        rows: '已處理',
        errors: '錯誤',
        accepted: '已接受',
        createdAt: '建立時間',
        action: '操作',
      },
      statuses: {
        uploaded: '已上傳',
        ready: '就緒',
        preflight_failed: '預檢失敗',
        committed: '已入庫',
        failed: '失敗',
        cancelled: '已取消',
        expired: '已過期',
      },
      actions: { view: '查看', commit: '入庫', cancel: '取消' },
      confirm: {
        commitTitle: '要入庫這個批次嗎？',
        commitBody: '就緒的 PIN 會寫入庫存。',
        cancelTitle: '要取消這個批次嗎？',
        cancelBody: '這個批次不會被匯入。',
        yes: '是',
        no: '否',
      },
      upload: {
        title: '上傳 PIN 檔案',
        hint: '檔案必須是 .xlsx 或 .csv，且有 pin_code 欄位標題。',
        skuId: 'SKU ID',
        drop: '將 .xlsx 或 .csv 拖到這裡',
        costPrice: '成本價',
        currency: '幣別',
        autoCommit: '預檢通過後自動入庫',
        cancel: '取消',
        submit: '上傳',
        skuRequired: '請輸入已存在的 SKU ID。',
        fileRequired: '請選擇 .xlsx 或 .csv 檔案。',
        costInvalid: '成本必須是最多 4 位小數的數字，例如 142.5000。',
        currencyInvalid: '幣別必須是 3 個字母，例如 TWD。',
        failed: '檔案未被接受。',
      },
      detail: {
        title: '匯入批次',
        close: '關閉',
        loading: '正在載入批次...',
        missing: '無法載入這個批次。',
        row: '列',
        stage: '階段',
        message: '訊息',
        noLogs: '尚無紀錄。',
      },
    },
  },
};
